import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const pdf = (path) => encodeURI(path);

const rows = [
  {
    id: "1",
    description: "Intimation of the closure of the trading window",
    link: pdf(
      "/assets/pdf/Regulation_30/Intimation_of_the_closure_of_the_trading_window.pdf"
    ),
  },
  {
    id: "2",
    description: "Hummingbird",
    link: pdf("/assets/pdf/Regulation_30/Reg_30_hummingbird.pdf"),
  },
  {
    id: "3",
    description: "BOC RERA",
    link: pdf("/assets/pdf/Regulation_30/Reg_30_for_the_BOC_RERA.pdf"),
  },
  {
    id: "4",
    description: "Clarification on Price Movement to BSE",
    link: pdf(
      "/assets/pdf/Regulation_30/Clarification_on_Price_Movement_to_BSE.pdf"
    ),
  },
];

const Regulation30 = () => {
  return (
    <>
      <Helmet>
        <title>Regulation 30</title>
      </Helmet>

      <div className="main-content">
        <Header />

        <div
          className="relative h-[30vh] sm:h-[40vh] md:h-[50vh] w-full bg-no-repeat bg-cover bg-center mb-3"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
          }}
        >
          <div className="absolute left-4 sm:left-8 md:left-12 top-1/2 transform -translate-y-1/2 text-xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-white px-4 sm:px-8 md:px-20 font-serif">
            Regulation 30
          </div>
        </div>

        <h2 className="text-center text-lg sm:text-2xl font-semibold text-[#F26624] mb-4 px-4">
          REGULATION 30
        </h2>

        <div className="w-[94%] md:w-[80%] lg:w-[70%] mx-auto border border-gray-300 mb-10 overflow-x-auto">
          <div className="bg-[#F26624] text-white text-sm font-medium py-2 px-1">
            <div className="flex">
              <div className="w-16 text-center border-r border-white/40">
                S.No
              </div>
              <div className="flex-1 text-center border-r border-white/40">
                Particulars
              </div>
              <div className="w-28 text-center">Link</div>
            </div>
          </div>

          {rows.map((row) => (
            <div
              key={row.id}
              className="bg-white border-b border-gray-300 text-xs hover:bg-gray-50"
            >
              <div className="flex">
                <div className="w-16 text-center border-r border-gray-300 py-2">
                  {row.id}
                </div>
                <div className="flex-1 px-3 py-2 border-r border-gray-300">
                  {row.description}
                </div>
                <div className="w-28 flex items-center justify-center">
                  <a
                    href={row.link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#F26624] hover:text-red-800 hover:underline text-sm font-semibold"
                  >
                    Click Here
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Regulation30;
